module.exports = __webpack_public_path__ + "img/alphabet03.7fee252e.png";